import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, FormGroup,
         Label, Input, Col } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { login } from '../../actions/loginActions';
import { connect } from 'react-redux';
import validator from 'validator';
import T from 'i18n-react';
/*for styling alert messages*/
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Alert from './../Alert/Alert';
import { hideAlert } from './../../actions/AlertActions';
import IndicatorLoading from './../indicatorLoading/IndicatorLoading';

const requirePhonenumber = <T.text tag='span' text="phone_req"/>;
const requireEmail = <T.text tag='span' text="email_req"/>;
const formatEmail = <T.text tag='span' text="email_format"/>;
const requirePincode = <T.text tag='span' text="pin_req"/>;
const charactersPincode = <T.text tag='span' text="pincode_digit_validation"/>;

class Login1 extends Component {
  constructor(props) {
    super(props);
    console.log('props: ', props);
    this.state = {
      phonenumber: '',
      phonenumberError: '',
      email: '',
      emailError: '',
      password: '',
      passwordError: ''
    };
    this.props.hideAlert();
  }

  onLoginClick = () => {
    console.log('on login cklick');
    if (!this.validationFields())
      return;
    this.props.login(this.state.phonenumber,
                      this.state.password,
                      this.state.email);
  }

  onEmailChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({email: val});
    //validation required
    if (!val)
      this.setState({emailError: requireEmail});
    else
      this.setState({emailError: ''});

    //email format cheking
    if ( val && !validator.isEmail(val) ){
      this.setState({emailError: formatEmail});
    }else if ( val && validator.isEmail(val) )
      this.setState({emailError: ''});
  }

  onPhoneChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({phonenumber: val});
    //validation required
    if (!val)
      this.setState({phonenumberError: requirePhonenumber});
    else
      this.setState({phonenumberError: ''});
  }

  onPassChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({password: val});
    //validation required
    if (!val)
      this.setState({passwordError: requirePincode});
    else if ( !validator.isNumeric(val) ){
      this.setState({passwordError: charactersPincode});
    }else
      this.setState({passwordError: ''});
  }

  validationFields(){
    let valid = true;
    /*required validation*/
    if (!this.state.phonenumber){
      this.setState({phonenumberError: requirePhonenumber});
      valid = false;
    }else
      this.setState({phonenumberError: ''});

    if (!this.state.password){
      this.setState({passwordError: requirePincode});
      valid = false;
    }else if ( !validator.isNumeric(this.state.password) ){
        this.setState({passwordError: charactersPincode});
        valid = false;
    }else
      this.setState({passwordError: ''});

    let emailVal = this.state.email;
    if (!emailVal){
      this.setState({emailError: requireEmail});
      valid = false;
    }else{
      //email format cheking
      if ( !validator.isEmail(emailVal) ){
        this.setState({emailError: formatEmail});
        valid = false;
      }else
        this.setState({emailError: ''});
    }

    return valid;
  }

  render() {
    const { typeMessage, messageText, showIndicator } = this.props;
    const message = {
      type: typeMessage,
      text: messageText
    }
      return(
        <div className="loginWrapper">
          <h4 className="title-screen">
            <T.text tag='span' text="login"/>
          </h4>
          <Form className="form-login">

           <FormGroup row>
             <Label for="exampleEmail" sm={4} md={3}>
               <T.span text={{ key: "enter_phone" }}/>
             </Label>
             <Col sm={8} md={6}>
               <Input type="text" name="phone" id="phoneNumber"
                 placeholder=""
                 onChange={this.onPhoneChange}
                 value={this.state.phonenumber}
                 className={(this.state.phonenumberError ? 'highlight-error' : '')}
               />

                 {this.state.phonenumberError &&
                   <p className="text-danger">{this.state.phonenumberError}</p>}
             </Col>
           </FormGroup>

           <FormGroup row>
             <Label for="emailField" sm={4} md={3}>
               <T.span text={{ key: "email_fld" }}/>
             </Label>
             <Col sm={8} md={6}>
               <Input type="text" name="emailField" id="emailField"
                 placeholder=""
                 onChange={this.onEmailChange}
                 value={this.state.email}
                 className={(this.state.emailError ? 'highlight-error' : '')}
               />

                 {this.state.emailError &&
                   <p className="text-danger">{this.state.emailError}</p>}
             </Col>
           </FormGroup>

           <FormGroup row>
             <Label for="examplePassword" sm={4} md={3}>
               <T.span text={{ key: "pincode" }}/>
             </Label>
             <Col sm={8} md={6}>
               <Input type="password" name="password" id="examplePassword"
                 autoComplete="new-password"
                 placeholder=""
                 onChange={this.onPassChange}
                 value={this.state.password}
                 className={(this.state.passwordError ? 'highlight-error' : '')}
               />

                 {this.state.passwordError &&
                   <p className="text-danger">{this.state.passwordError}</p>}
             </Col>
           </FormGroup>

          {/*  <FormGroup row>
             <Col sm={12} md={9}>
                <a href="#" className="rgt">I forgot my pincode</a>
             </Col>
           </FormGroup> */}

           <FormGroup row>
             <Col sm={12} md={9}>
                <Button color="warning" className="login-btn rgt"
                  onClick={() => this.onLoginClick()}>
                    <T.text tag='span' text="login"/>
                  </Button>
            </Col>
           </FormGroup>

           <FormGroup row>
             <Col sm={12} md={9}>
                <NavLink to="/signup" className="rgt">
                  <T.text tag='span' text="no_account"/>
                </NavLink>
             </Col>
           </FormGroup>
         </Form>
         <ReactCSSTransitionGroup
              transitionName="appear"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}>
         {messageText && <Alert message={message} />}
         </ReactCSSTransitionGroup>

        { showIndicator &&
          <IndicatorLoading/>
        }

        </div>
    )
  }
}

export default connect(
  (state)=>{
  return{
    typeMessage: state.alert.type,
    messageText: state.alert.message,
    showIndicator: state.authReducer.showIndicator
  }
},
  { login, hideAlert }
)(Login1);



// WEBPACK FOOTER //
// ./src/components/login/Login.js